import { accountsEnvironment } from '../accounts-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { AuthHeaders } from '../../../models/auth-headers';
import { addOnSchema } from '../schemas/add-on';
import { z } from 'zod/v4';
import { fromFetch } from 'rxjs/fetch';

const responseSchema = z.array(
  z.object({
    productId: z.number().min(1),
    addons: z.array(addOnSchema).nullable().optional(),
    productName: z.string().min(1),
    applicationId: z.number().min(1),
    features: z.array(
      z.object({
        featureId: z.number().min(1),
        featureName: z.string().min(1),
      })
    ),
  })
);

/**
 * Get a list of mobile products with allowed license features for a company
 * @returns An array of Company Mobile Products
 */
export function getCompanyMobileproducts(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${accountsEnvironment.resolve(this).companyUrl}/mobileproducts`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
              ? new AuthHeaders()
              : jwtAuthHeaders),
          },
        }
      )
    )
  ).pipe(selectData(responseSchema));
}
